import jwt from 'jsonwebtoken';

/**
 * Service for saving and retrieving the app state to and from local storage
 */

/**
 * Loads the state from local storage
 *
 * @returns {object} - Object representing the state retrieved from local storage
 *   or undefined if the state cannot be loaded.
 */
export const loadState = () => {
  try {
    const serializedState = localStorage.getItem('state');
    if (serializedState === null) {
      return undefined;
    }
    const parsedState = JSON.parse(serializedState);
    const decodedToken = jwt.decode(parsedState.user.credentials.accessToken);

    if (decodedToken !== null) {
      if (decodedToken.exp !== null && decodedToken.exp < Date.now()) {
        return undefined;
      }
    }
    return parsedState;
  } catch (err) {
    return undefined;
  }
};

export const loadOrgImpersonationId = (storage) => {
  try {
    return JSON.parse(storage.getItem('state')).user.identity.impersonatedOrganizationId || null;
  } catch (err) {
    storage.setItem('stateError', JSON.stringify(err));
    return null;
  }
};

/**
 * Saves the state to local storage
 *
 * @param {object} state - State to save in local storage
 */
export const saveState = (state) => {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem('state', serializedState);
  } catch (err) {
    localStorage.setItem('stateError', JSON.stringify(err));
  }
};
